import { CSSObject } from '@chakra-ui/react';

export const Accordion: CSSObject = {
  border: '1px',
  borderColor: 'delta.300',
  borderRadius: 'base',
  overflow: 'hidden',
  bg: 'gray.200',

  '.chakra-accordion__item': {
    _first: {
      borderTop: '0',
    },
    _last: {
      borderBottom: '0',
    },
  },

  '.chakra-accordion__panel': {
    color: 'gray.600',
  },
};

export const AccordionHeader: CSSObject = {
  bg: 'white',
  color: 'epsilon.500',
  transitionDuration: 'normal',
  transitionProperty: 'common',
  _hover: {
    bg: 'epsilon.300',
    color: 'white',
  },
  _focus: {
    bg: 'epsilon.300',
    color: 'white',
  },
};

export const OverviewPromotionsPanel: CSSObject = {
  bgColor: 'epsilon.400',
};

export const AccordionHeaderLogOut: CSSObject = {
  borderColor: 'delta.300',
  borderRadius: 'base',
  _hover: {
    bg: 'epsilon.300',
  },
  _focus: {
    bg: 'epsilon.300',
  },
};

export const IconPerson: CSSObject = {
  boxSize: ['5', null, '6'],
  mr: '1.5',
};

export const TextAccordion: CSSObject = {
  fontSize: ['xs', null, 'sm'],
  fontWeight: 'semibold',
  mr: 'auto',
};

export const FlexContactToChange: CSSObject = {
  alignItems: 'center',
  bg: 'epsilon.400',
  borderRadius: 'base',
  boxShadow: '0 4px 5px rgba(0, 0, 0, .1)',
  color: 'white',
  fontSize: 'xs',
  gap: '1',
  p: '2',
};

export const OverviewAccordionItem: CSSObject = {
  borderTop: 'none',
};
